import { buildApiUrl, Type, sendGetRequest } from '@/api/api';
import { assertSchemaAndCoerce } from '@/shared/utils/schemas/assertions'
import { z } from 'zod'

export const tariffNameSchema = z.array(z.object({
  Id: z.number(),
  ProviderId: z.number(),
  Name: z.string()
}))

export async function fetchTariffNames(providers: number[]) {
  const query = providers.map(id => `providerIds=${id}`).join('&');
  const url = buildApiUrl(Type.TariffManagement, `tariffs/names?${query}`)
  const { data } = await sendGetRequest(url)
  return assertSchemaAndCoerce(data, tariffNameSchema)
}
